import { useEffect, useRef } from 'react';
import { glowHoverEffect } from './glow-hover-effect';
export var useGlowHover = function useGlowHover(_a) {
  var hoverBg = _a.hoverBg,
      lightColor = _a.lightColor,
      _b = _a.lightSize,
      lightSize = _b === void 0 ? 100 : _b,
      _c = _a.lightSizeEnterAnimationTime,
      lightSizeEnterAnimationTime = _c === void 0 ? 100 : _c,
      _d = _a.lightSizeLeaveAnimationTime,
      lightSizeLeaveAnimationTime = _d === void 0 ? 50 : _d,
      _e = _a.isElementMovable,
      isElementMovable = _e === void 0 ? false : _e,
      _f = _a.customStaticBg,
      customStaticBg = _f === void 0 ? null : _f;
  var ref = useRef(null);
  useEffect(function () {
    return ref.current ? glowHoverEffect(ref.current, {
      hoverBg: hoverBg,
      lightColor: lightColor,
      lightSize: lightSize,
      lightSizeEnterAnimationTime: lightSizeEnterAnimationTime,
      lightSizeLeaveAnimationTime: lightSizeLeaveAnimationTime,
      isElementMovable: isElementMovable,
      customStaticBg: customStaticBg
    }) : function () {};
  }, [hoverBg, lightColor, lightSize, lightSizeEnterAnimationTime, lightSizeLeaveAnimationTime, isElementMovable, customStaticBg]);
  return ref;
};
//# sourceMappingURL=use-glow-hover.js.map